/* The same conservative vocabulary is used by the theme and the local search. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else {
    root.CabaneDiscoverySearch = api;
    document.addEventListener('submit', event => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !/\/search\/?$/.test(new URL(form.action, location.href).pathname)) return;
      const input = form.querySelector('[name="q"]');
      if (input && !['127.0.0.1','localhost'].includes(location.hostname)) input.value = api.normalizeQuery(input.value);
    }, true);
  }
})(typeof window === 'undefined' ? globalThis : window, function () {
  const fold = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const groups = [
    [window.CabaneI18n.pick("trottinette","Scooter"), window.CabaneI18n.pick("trottinettes","Scooters"), 'scooter', 'scooters', 'trot', 'trott', 'trottinete', 'trottinet', 'trotinette', 'trotinettes', 'trotinete'],
    ['guidon', window.CabaneI18n.pick("guidons","Handlebars"), 'bar', 'bars', 'handlebar', 'handlebars'],
    ['roue', window.CabaneI18n.pick("roues","Wheels"), 'wheel', 'wheels'],
    ['casque', window.CabaneI18n.pick("casques","Helmets"), 'helmet', 'helmets'],
    ['skateboard', 'skateboards', 'skate', 'skates', 'skatebord', 'skatebords'],
    [window.CabaneI18n.pick("roller","Skating"), window.CabaneI18n.pick("rollers","Skates"), 'rolller', 'roler'],
    ['genouillere', 'genouilleres', 'genouilere', 'kneepad', 'kneepads'],
    ['fourche', window.CabaneI18n.pick("fourches","Forks"), 'fork', 'forks'],
    ['roulement', window.CabaneI18n.pick("roulements","Bearings"), 'bearing', 'bearings'],
    ['poignee', 'poignees', 'handlegrip', 'handlegrips'],
    ['frein', window.CabaneI18n.pick("freins","Brakes"), 'brake', 'brakes'],
    ['collier', 'colliers', 'clamp', 'clamps']
  ];
  const lookup = new Map(groups.flatMap(group => group.map(word => [word, group])));
  // Advanced navigation clauses and quoted model names are intentionally exact.
  const technical = query => /(?:\b(?:title|vendor|tag|product_type|body):|\b(?:AND|OR|NOT)\b|[()*"]|(?:^|\s)-\S)/.test(query);
  const words = query => String(query || '').trim().split(/\s+/).map(word => word.replace(/^[,;:!?]+|[,;:!?]+$/g, '')).filter(Boolean);
  function normalizeQuery(query) {
    if (technical(query)) return String(query).trim();
    return words(query).map(word => lookup.get(fold(word))?.[0] || word).join(' ');
  }
  function alternatives(word) {
    return lookup.get(fold(word)) || [fold(word)];
  }
  return { normalizeQuery, alternatives, technical, fold, words };
});
